
  import ScreenSize from '@/mixins/ScreenSize';
  import Events from '@/events/Events';
  import EventBus from '@/events/EventBus';
  import {popupCenter} from '@/helper/PopupHelper';
  import DialogsBaseSection from '@/components/sections/DialogsBaseSection.vue';
  import ModelItems from '@/mixins/ModelItems';
  import RegistrationAndApplication from '@/mixins/RegistrationAndApplication';
  import {prepareServerSideValidationErrors} from '@/helper/FormHelper';
  import {
    prepareOAuthRedirectUrlWithUtmCookie,
    prepareUrl,
  } from '@/helper/UrlHelper';
  import UploadMiscDocuments from '@/mixins/UploadMiscDocuments';
  import UploadResumeDocuments from '@/mixins/UploadResumeDocuments';

  export default {
    name: 'RegistrationAndApplicationForm',
    components: {
      DialogsBaseSection,
      RichText: () => import('@/components/elements/RichText'),
      CheckboxRichText: () => import('@/components/elements/CheckboxRichText'),
    },
    mixins: [
      ModelItems,
      RegistrationAndApplication,
      ScreenSize,
      UploadMiscDocuments,
      UploadResumeDocuments,
    ],
    props: {
      job: {
        type: Object,
        required: false,
        default: () => {},
      },
      comeFrom: {
        type: String,
        required: false,
        default: 'detailPage',
      },
      position: {
        type: String,
        required: false,
        default: 'NULL',
      },
    },
    data() {
      return {
        loginItems: [],
        section: {},
        registerAndApplyData: {
          email: '',
          notes: '',
          firstName: '',
          lastName: '',
          phone: '',
          applicationText: false,
          terms: false,
          advertisingConsent: null,
        },
        currentOrganization: {},
        organizationLink: '',
        organizationLinkText: '',
        disable: false,
        buttonsMenu: false,
        fileInput: [],
      };
    },
    methods: {
      switchToLogin() {
        this.$emitWithClientData(
          Events.RegistrationAndApplicationStepFinished,
          {
            step: 'Application',
            jobPostingId: this.job.id,
          }
        );
        this.$emitWithClientData(Events.RegistrationAndApplicationStepStarted, {
          step: 'Login',
          jobPostingId: this.job.id,
        });
        this.$emit('change-dialog-page', 'login');
      },
      checkEmail(val) {
        if (!val) {
          return;
        }

        // cancel pending call
        clearTimeout(this._timerId);

        // delay new call
        this._timerId = setTimeout(() => {
          this.registerAndApply(true);
        }, 300);
      },
      registerAndApply(getParameters) {
        this.disable = true;
        const registerData = {
          firstName: this.registerAndApplyData.firstName,
          lastName: this.registerAndApplyData.lastName,
          email: this.registerAndApplyData.email,
          mobile: this.registerAndApplyData.phone,
          jobPostingId: this.job.id,
          notes: this.registerAndApplyData.notes || '',
          advertisingConsent: this.registerAndApplyData.advertisingConsent,
        };
        if (this.organizationLink) {
          registerData.assignToOrganization = this.$cookies.get(
            'organization_parameter'
          ).id;
        }
        this.$store
          .dispatch('api/candidateProfile/postRegistrationAndApply', {
            data: registerData,
            getParameters: getParameters ? {dry_run: 1} : {dry_run: 0},
          })
          .then(async (response) => {
            const loginData = {
              email: this.registerAndApplyData.email,
              password: response.data.password,
            };
            if (response.status === 201) {
              await this.$auth
                .loginWith('local', {data: loginData})
                .then(async () => {
                  if (this.fileInput.length > 0) {
                    this.saveResumeFile();
                  }
                  await this.$localforage.setItem('SavedApplyJob', this.job);
                  this.registerAndApplyData.notes = '';
                  this.registerAndApplyData.email = '';
                  this.registerAndApplyData.firstName = '';
                  this.registerAndApplyData.lastName = '';
                  this.registerAndApplyData.phone = '';
                  this.registerAndApplyData.applicationText = false;
                  this.registerAndApplyData.terms = false;
                  EventBus.$emit('applied-on-job', this.job.id);
                  this.$emitWithClientData(
                    Events.RegistrationAndApplicationStepFinished,
                    {
                      step: 'Application',
                      jobPostingId: this.job.id,
                    }
                  );
                  this.$emitWithClientData(
                    Events.RegistrationAndApplicationFinished,
                    {
                      jobPostingId: this.job.id,
                    }
                  );
                  this.$emitWithClientData(Events.Registered, {
                    channel: 'application',
                    jobPostingId: this.job.id,
                    position: this.position,
                    advertisingConsent:
                      this.registerAndApplyData.advertisingConsent,
                    type: 'RegistrationAndApplication',
                  });
                  this.$notifications.showNotification({
                    message: this.$t('register_and_job_apply.success'),
                    color: 'success',
                    timeout: 15000,
                  });
                  const trackingObj = {
                    jobPostingId: this.job.id,
                    comeFrom: this.comeFrom,
                    flow: 'RegistrationAndApplication',
                  };
                  if (this.organizationLink) {
                    trackingObj.assign_to_organization = this.$cookies.get(
                      'organization_parameter'
                    ).id;
                  }
                  this.$emitWithClientData(Events.JobAppliedTo, trackingObj);

                  const queryParams = {...this.$route.query};
                  queryParams.successApplication = 1;
                  this.$router.push(
                    this.localePath({
                      name: this.$router.url,
                      query: queryParams,
                    })
                  );

                  this.$emit('close-dialog');
                });
            }
          })
          .catch((e) => {
            this.disable = false;
            if (e.response.status === 422 && getParameters) {
              const violations = [];
              e.response.data.violations.map((violation) => {
                if (violation.code === 'afe78f6b-7932-50b3-8107-e14c5fa78a84') {
                  violations.push(violation);
                }
              });
              e.response.data.violations = violations;
              this.$refs.form.setErrors(
                prepareServerSideValidationErrors(e.response)
              );
            }
            if (e.response.status === 422 && !getParameters) {
              e.response.data.violations.map((violation) => {
                if (violation.code === 'afe78f6b-7932-50b3-8107-e14c5fa78a84') {
                  this.$notifications.showNotification({
                    message: violation.message,
                    color: 'error',
                    timeout: 5000,
                  });
                }
                if (violation.code === '70997997-76fb-31fe-fe4a-941682389870') {
                  this.$notifications.showNotification({
                    message: violation.message,
                    color: 'error',
                    timeout: 5000,
                  });
                }
                if (violation.code === 'e93d15f3-54ce-e48f-6ade-ef4ea0d591b1') {
                  this.$notifications.showNotification({
                    message: violation.message,
                    color: 'error',
                    timeout: 5000,
                  });
                }
                this.$refs.form.setErrors(
                  prepareServerSideValidationErrors(e.response)
                );
              });
            } else {
              throw e;
            }
          });
      },
      doTheLogin(method) {
        if (method.title === 'Apple') {
          this.$emitWithClientData(
            Events.RegistrationAndApplicationSwitchToApple,
            {
              type: 'Application',
              jobPostingId: this.job.id,
            }
          );
          this.appleRegistration();
        } else if (method.title === 'Facebook') {
          this.$emitWithClientData(
            Events.RegistrationAndApplicationSwitchToFacebook,
            {
              type: 'Application',
              jobPostingId: this.job.id,
            }
          );
          this.facebookRegistration();
        } else if (method.title === 'Google') {
          this.$emitWithClientData(
            Events.RegistrationAndApplicationSwitchToGoogle,
            {
              type: 'Application',
              jobPostingId: this.job.id,
            }
          );
          this.googleRegistration();
        } else {
          this.$emitWithClientData(
            Events.RegistrationAndApplicationSwitchToMicrosoft,
            {
              type: 'Application',
              jobPostingId: this.job.id,
            }
          );
          this.microsoftRegistration();
        }
      },
      async appleRegistration() {
        const utm = this.$cookies.get('utm') ? this.$cookies.get('utm') : {};
        utm.channel = 'apple_application';
        await this.$localforage.setItem('RegistrationPosition', this.position);
        await this.$localforage.setItem(
          'RegistrationJobPostingId',
          this.job.id
        );
        popupCenter({
          url: prepareUrl(
            process.env.NUXT_ENV_API_DOMAIN +
              process.env.NUXT_ENV_API_REGISTER_APPLE_ENDPOINT,
            {
              getParameters: {
                redirectUrl: prepareOAuthRedirectUrlWithUtmCookie(utm),
              },
            }
          ),
          title: 'Apple Registrierung',
          w: 400,
          h: 600,
        });
      },
      async facebookRegistration() {
        const utm = this.$cookies.get('utm') ? this.$cookies.get('utm') : {};
        utm.channel = 'facebook_application';
        await this.$localforage.setItem('RegistrationPosition', this.position);
        await this.$localforage.setItem(
          'RegistrationJobPostingId',
          this.job.id
        );
        popupCenter({
          url: prepareUrl(
            process.env.NUXT_ENV_API_DOMAIN +
              process.env.NUXT_ENV_API_REGISTER_FACEBOOK_ENDPOINT,
            {
              getParameters: {
                redirectUrl: prepareOAuthRedirectUrlWithUtmCookie(utm),
              },
            }
          ),
          title: 'Facebook Registrierung',
          w: 400,
          h: 600,
        });
      },
      async googleRegistration() {
        const utm = this.$cookies.get('utm') ? this.$cookies.get('utm') : {};
        utm.channel = 'google_application';
        await this.$localforage.setItem('RegistrationPosition', this.position);
        await this.$localforage.setItem(
          'RegistrationJobPostingId',
          this.job.id
        );
        popupCenter({
          url: prepareUrl(
            process.env.NUXT_ENV_API_DOMAIN +
              process.env.NUXT_ENV_API_REGISTER_GOOGLE_ENDPOINT,
            {
              getParameters: {
                redirectUrl: prepareOAuthRedirectUrlWithUtmCookie(utm),
              },
            }
          ),
          title: 'Google Registrierung',
          w: 400,
          h: 600,
        });
      },
      async microsoftRegistration() {
        const utm = this.$cookies.get('utm') ? this.$cookies.get('utm') : {};
        utm.channel = 'microsoft_application';
        await this.$localforage.setItem('RegistrationPosition', this.position);
        await this.$localforage.setItem(
          'RegistrationJobPostingId',
          this.job.id
        );
        popupCenter({
          url: prepareUrl(
            process.env.NUXT_ENV_API_DOMAIN +
              process.env.NUXT_ENV_API_REGISTER_MICROSOFT_ENDPOINT,
            {
              getParameters: {
                redirectUrl: prepareOAuthRedirectUrlWithUtmCookie(utm),
              },
            }
          ),
          title: 'Microsoft Registrierung',
          w: 400,
          h: 600,
        });
      },
    },
  };
